import { action, computed, reaction, makeObservable } from 'mobx';
import {Disposers} from '../../../../../lib/helpers';
import {ReactFlipperStore} from '../../../../../lib/components';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {FlashcardsModel} from '../models';
import {FlashcardsState, FlashcardState} from './models';

export class FlashcardsStore {
  private readonly disposers = new Disposers();

  readonly flippers: readonly ReactFlipperStore[];

  constructor(readonly id: number,
              readonly model: FlashcardsModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
    this.flippers = model.cards.map(() => new ReactFlipperStore());
    this.setup();
  }

  @computed
  get flashcardsState(): FlashcardsState | null {
    const cards: FlashcardState[] = Array(this.model.cards.length).fill({ flipped: false })
    const altFlashcardsState: FlashcardsState = { cards }
    return this.stateStore.getContentState<FlashcardsState>(this.id) !== null ? this.stateStore.getContentState<FlashcardsState>(this.id) : altFlashcardsState;
  }

  // Direction of state change:
  // 1. this.toggle
  // 2. this.updateState
  // 3. this.flashcardsState update (from KeyValues)
  // 4. this.flippers state update (from reaction)

  @action
  toggle = (index: number) => {
    if (this.flashcardsState === null)
      return;
    const cards = this.flashcardsState.cards.slice();
    const tmp = cards[index];
    cards[index] = {flipped: !tmp.flipped};
    this.updateState({cards: cards});
  };

  private setup() {
    this.disposers.add(
      reaction(
        () => this.flashcardsState,
        this.updateFlippers,
        {fireImmediately: true}
      )
    );
  }

  @action
  private updateFlippers = () => {
    if (this.flashcardsState === null)
      return;
    for (let index = 0; index < this.flashcardsState.cards.length; index++) {
      const card = this.flashcardsState.cards[index];
      const flipper = this.flippers[index];
      flipper.setIsFlipped(card.flipped);
    }
  };

  @action
  private updateState(state: FlashcardsState) {
    this.stateStore.setContentState<FlashcardsState>(this.id,
      state);
  }

  dispose() {
    this.disposers.dispose();
  }
}
